<template>
  <div class="r_h_100">
    <div class="r_h_100" v-if="!worker_loaded">
      <loadingCube :loadingMessage="'WORKER'"></loadingCube>
    </div>
    <div v-else id="worker_right_info">
      <div id="ri_w_top">
        <template v-if="$store.state.auth.me.roles.includes('admin')">
          <button @click.prevent="export_worker" class="btn orcaBtn sm_btn warning mb-2 mr-1 ml-1" :disabled="worker_export">
            <span v-if="!worker_export"><i class="fas fa-file-upload"></i>&nbsp;Export</span>
            <span v-else-if="worker_export"><i class="fas fa-spinner fa-pulse"></i> &nbsp; Exporting</span>
          </button>
        </template>
        <button class="btn orcaBtn grey_bg" id="right_info_close" data-toggle="tooltip" title="Close information"
          @click="close_right_info"><i class="fas fa-times"></i> &nbsp;
          CLOSE
        </button>
        <div class="quick_btns">
          <div class="row">
            <div class="col-12 pl-0 pr-0">
              <button @click="add_to_finance_export_accounts" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') ||
                $store.state.auth.me.roles.includes('accounts')) && !in_ac_export"
                class="btn orcaBtn purpleBtn mb-2 mr-1" data-toggle="tooltip" title="Add worker to accounts export">
                <i class="fas fa-leaf"></i>&nbsp;A
              </button>
              <button @click="add_to_finance_export_payroll" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') ||
                $store.state.auth.me.roles.includes('accounts')) && !in_p_export"
                class="btn orcaBtn purpleBtn mb-2 mr-1" data-toggle="tooltip" title="Add worker to payroll export">
                <i class="fas fa-leaf"></i>&nbsp;P
              </button>
              <button @click="add_to_finance_export_tax" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') ||
                $store.state.auth.me.roles.includes('accounts')) && !in_t_export"
                class="btn orcaBtn purpleBtn mb-2 mr-1" data-toggle="tooltip" title="Add worker to payroll export">
                <i class="fas fa-leaf"></i>&nbsp;T
              </button>
            </div>
            <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') ||
              $store.state.auth.me.roles.includes('accounts'))" class="col-12 pl-0 pr-0">
              <template v-if="$store.state.auth.me.roles.includes('admin')">
                <button
                    class="btn orcaBtn greenBtn mb-2 mr-1"
                    v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type_id !== 33"
                    @click="$router.push({ path: '/workers/profile', query: { worker_id: worker.id, tab: 'cis' } })"
                >
                  CIS
                </button>
              </template>
              <button @click="show_profile_worker" class="btn orcaBtn greenBtn mb-2 mr-1" data-toggle="tooltip"
                title="View Profile"><i class="fas fa-user"></i></button>
              <button @click="show_edit_worker" class="btn orcaBtn blueBtn mb-2 mr-1" data-toggle="tooltip"
                title="Edit Worker"><i class="fas fa-user-edit"></i></button>
              <button v-if="!worker.new_starters.verified_at && !worker_reg_verified" 
                @click="verify_worker" class="btn orcaBtn greenBtn mb-2 mr-1" 
                title="Verify Worker Login"><i class="fas fa-check-circle"></i></button>
              <button @click="delete_worker" class="btn orcaBtn danger mb-2 mr-1" data-toggle="tooltip" 
                title="Delete Worker"><i class="fas fa-trash-alt"></i></button>
              <hr>
            </div>
          </div>
        </div>
        <!-- Worker information -->
        <h2 class="font-weight-bold bp_color mb-0">{{ full_name }}</h2>
        <h5 v-if="worker.rel_profile.job_title_id !== null">{{ worker.rel_profile.job_title.job_title }}</h5>
        <p class="b3_color mb-0" v-if="worker.rel_company_info.employment_type_id !== null">{{
          worker.rel_company_info.employment_type.value
        }}</p>

        <p class="b3_color mb-0 font-weight-bold" v-if="worker.rel_company_info.company_internal_finance_ref !== null">
          C. Ref: {{ worker.rel_company_info.company_internal_finance_ref }}
        </p>
        <p class="b3_color mb-0" v-if="worker.rel_company_info.historical_internal_finance_ref !== null">
          Historical C. Ref: {{ worker.rel_company_info.historical_internal_finance_ref }}
        </p>
        <p class="b3_color mb-0 font-weight-bold">
          W. Ref: {{ worker.internal_finance_ref }}</p>

        <p class="b3_color mb-0 font-weight-bold">
          Orca ID: {{ worker.id }}</p>

        <!--        <div class="quick_action_btns mt-2">-->
        <!--          <button @click="createEmail" class="btn orcaBtn mb-2 mr-1 disabled" disabled data-toggle="tooltip" title="Send Email"><i class="fas fa-paper-plane"></i> &nbsp; Email-->
        <!--          </button>-->
        <!--          <button @click="createEvent" class="btn orcaBtn mb-2 mr-2 ml-2 disabled" disabled data-toggle="tooltip" title="Create Event"><i class="fas fa-calendar-plus"></i> &nbsp;-->
        <!--            Event-->
        <!--          </button>-->
        <!--          <button @click="createTask" class="btn orcaBtn mb-2 ml-1 disabled" disabled data-toggle="tooltip" title="Create Task"><i class="fas fa-plus-square"></i> &nbsp; Task-->
        <!--          </button>-->
        <!--        </div>-->
        <hr>
      </div>
      <div class="ri_w_after_top">
        <div class="row">
          <div v-if="phones.personal_mobile !== null" class="col-xl-4 font-weight-bold">Mobile:</div>
          <div v-if="phones.personal_mobile !== null" class="col-xl-8">{{ phones.personal_mobile.phone_number }}</div>
          <div v-if="phones.personal_landline !== null" class="col-xl-4 font-weight-bold">Landline:</div>
          <div v-if="phones.personal_landline !== null" class="col-xl-8">{{ phones.personal_landline.phone_number }}
          </div>
          <div v-if="emails.website_login !== null" class="col-xl-4 font-weight-bold">Email:</div>
          <div v-if="emails.website_login !== null" class="col-xl-8">{{ emails.website_login.email_address }}</div>
          <div class="col-xl-7 font-weight-bold">
            <!-- <hr class="mt-2 mb-2"> -->
          </div>
          <div class="col-xl-5"></div>
          <div class="col-xl-4 font-weight-bold">NI Number:</div>
          <div class="col-xl-8">
            <span v-if="worker.rel_profile.ni_number !== null">{{ worker.rel_profile.ni_number }}</span>
          </div>
        </div>
        <div class="row"
          v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type.value !== 'PAYE'">
          <div class="col-xl-4 font-weight-bold">Personal UTR:</div>
          <div class="col-xl-8">{{ worker.rel_profile.personal_utr_number }}</div>
        </div>
        <div class="row">
          <div class="col-xl-4 font-weight-bold">Login Verified:</div>
          <div v-if="worker.new_starters.verified_at" class="col-xl-8">{{ worker.new_starters.verified_at }}</div>
          <div v-else class="col-xl-8"><strong>UNVERIFIED</strong></div>
        </div>
        <div class="row" v-if="worker.rel_company_info.employment_type_id !== null && (worker.rel_company_info.employment_type.value === 'Sole Trader' ||
          worker.rel_company_info.employment_type.value === 'Limited')">
          <div class="col-xl-7 font-weight-bold">
            <hr class="mt-2 mb-2">
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12">
            <hr>
          </div>
        </div>
        <div class="row" v-if="worker.rel_company_info.employment_type_id !== null && (worker.rel_company_info.employment_type.value === 'Sole Trader' ||
          worker.rel_company_info.employment_type.value === 'Limited')">
          <div class="col-xl-4 font-weight-bold">Trading Name:</div>
          <div class="col-xl-8">{{ worker.rel_company_info.company_trading_name }}</div>
          <div class="col-xl-4 font-weight-bold">Company UTR:</div>
          <div class="col-xl-8">{{ worker.rel_company_info.company_utr_number }}</div>
          <div v-if="worker.rel_company_info.employment_type.value === 'Limited'" class="col-xl-4 font-weight-bold">
            Company LTD Number:</div>
          <div v-if="worker.rel_company_info.employment_type.value === 'Limited'" class="col-xl-8">{{
            worker.rel_company_info.company_ltd_reg_number
          }}</div>
          <div class="col-12">
            <hr>
          </div>
        </div>

        <!-- Current Assignment -->
        <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager') ||
              $store.state.auth.me.roles.includes('accounts'))">
          <div class="ri_w_section">
            <div v-if="worker.new_starters.verified_at" class="row">
              <div class="col-12">
                <h5 class="bp_color">Latest Assignment</h5>
              </div>
            </div>
            <div v-if="assignments_loaded">
              <button v-if="notEmptyObject(assignments)" @click="view_all_assignments"
                class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="View Assignments">
                <i class="fas fa-sitemap"></i> &nbsp; View All
              </button>
              <div class="row mt-1">
                <div v-if="notEmptyObject(assignments)" class="col-12">
                  <div class="latest_assignment_buttons">
                    <button @click="end_current_assignment(assignments[0].id)" class="btn orcaBtn warning sm-btn"
                      data-toggle="tooltip" title="End Assignment">
                      <i class="fas fa-stop"></i>
                    </button>
                    <button @click="show_assignment_order" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                      title="View Order">
                      <i class="fas fa-clipboard-list"></i>
                    </button>
                  </div>
                  <div class="latest_assignment">
                    <span class="font-weight-bold d-block">{{ assignments[0].company.company_name }}</span>
                    <span class="d-block">
                      <span class="bp_color font-weight-bold">{{ assignments[0].order_job.order_ref }}</span> {{
                        assignments[0].order_job.rel_order_location.short_site_name
                      }}
                    </span>
                    <span class="d-block">
                      <strong>Duration:</strong>
                      {{ assignments[0].start_date | formatDate }} - {{
                        assignments[0].end_date | formatDate
                      }}
                    </span>
                  </div>
                </div>
                <div v-else class="col-12 ri_w_no_content">
                  <div v-if="!worker.new_starters.verified_at && !worker_reg_verified">
                      <p class="ri_w_label">Worker account not verified!</p>
                      <button @click="verify_worker" class="btn orcaBtn greenBtn sm_btn float-right"><i class="fas fa-check-circle"></i>
                        Verify Now</button>
                  </div>
                  <div v-else>
                  <p class="ri_w_label">No Live Assignments.</p>
                  <button @click="new_assignment" class="btn orcaBtn sm_btn float-right"><i class="fas fa-plus"></i>
                    Assign</button>
                    </div>
                </div>
                <div v-else class="col-12 ri_w_no_content">
                  <p class="ri_w_label">Account not yet verified.</p>
                  <button @click="verify_worker" class="btn orcaBtn greenBtn sm_btn float-right"><i class="fas fa-check-circle"></i>
                    Verify Now</button>
                </div>
              </div>

              <div class="ri_w_section"
                v-if="notEmptyObject(most_recent_unassigned_assignments) && Object.keys(assignments).length === 0">
                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <h5 class="bp_color">Last Assigned To</h5>
                  </div>
                </div>
                <div class="col-12">
                  <div class="latest_assignment">
                    <span class="font-weight-bold d-block">{{
                      most_recent_unassigned_assignments[0].company.company_name
                    }}</span>
                    <span class="d-block">
                      <span class="bp_color font-weight-bold">{{
                        most_recent_unassigned_assignments[0].order_job.order_ref
                      }}</span> {{
                                  most_recent_unassigned_assignments[0].order_job.rel_order_location.short_site_name
                                }}
                    </span>
                    <span class="d-block">
                      <strong>Duration:</strong>
                      {{ most_recent_unassigned_assignments[0].order_job.rel_order_position.start_date | formatDate }}
                      {{ most_recent_unassigned_assignments[0].order_job.rel_order_position.end_date | formatDate }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <hr>
                </div>
              </div>
            </div>
            <div v-else class="row mt-1">
              <div class="col-12">
                <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Assignments</span>
              </div>
              <div class="col-12">
                <hr>
              </div>
            </div>
          </div>

          <!-- Compliance Tests -->
          <div
            v-if="worker.rel_company_info.employment_type_id !== null && worker.rel_company_info.employment_type.value !== 'PAYE'"
            class="ri_w_section">
            <div class="row">
              <div class="col-12">
                <h5 class="bp_color">Compliance Test</h5>
              </div>
            </div>
            <div v-if="entity_test_loaded" class="row">
              <div class="col-12 latest_entity_test" :class="checkTest(worker_compliance_test)"
                v-if="notEmptyObject(worker_compliance_test)">
                <button @click="view_entity_test(worker_compliance_test.id)" class="btn orcaBtn greenBtn sm-btn"
                  data-toggle="tooltip" title="View Entity Test">
                  <i class="fas fa-eye"></i>
                </button>
                <span class="test_status">{{ checkTest(worker_compliance_test) }}</span>
                <div class="test_info">
                  <span class="test_date">Test date: {{ worker_compliance_test.updated_at | formatDateTime }}</span>
                  <span class="test_created_at">
                    By <span v-if="worker_compliance_test.created_log !== undefined && worker_compliance_test.created_log !== null && worker_compliance_test.created_log.log_by_type ===
                      'App\\Models\\Users\\User' && worker_compliance_test.created_log.log_by !== undefined && worker_compliance_test.created_log.log_by !== null">:
                      {{ worker_compliance_test.created_log.log_by.first_name }} {{
                        worker_compliance_test.created_log.log_by.surname
                      }}</span><span v-else>Worker</span>
                  </span>
                </div>
              </div>
              <div v-else class="col-12 ri_w_no_content">
                <p class="ri_w_label">No Compliance Test Completed</p>
                <button @click="new_entity_test" class="btn orcaBtn blueBtn sm-btn" data-toggle="tooltip"
                  title="New Entity Test"><i class="fas fa-vial"></i> &nbsp; New</button>
              </div>
            </div>
            <div v-else class="row mt-2">
              <div class="col-12">
                <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Entity Test</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
          </div>

          <!-- Notes -->
          <div class="ri_w_section">
            <div class="row">
              <div class="col-12">
                <h5 class="bp_color">Notes</h5>
              </div>
            </div>
            <button @click="add_note_modal" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip"
              title="Add note to worker"><i class="fas fa-plus"></i> &nbsp; add note
            </button>
            <div v-if="notes_loaded" class="row mt-1">
              <div v-if="notEmptyObject(notes)" class="col-12">
                <div v-for="note in notes" class="last_notes">
                  <button @click="view_note_modal(note.id)" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                    title="View Worker Note"><i class="fas fa-eye"></i></button>
                                    <div class="note_details">
                    <span class="note_type">{{ note.note_type.note_type }}</span>
                    <span class="note_user_created_at">{{ note.note_log_by.first_name }} {{ note.note_log_by.surname }}
                      - {{ note.updated_at | formatDateTime }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="col-12 ri_w_no_content">
                <p class="ri_w_label">No Notes left on worker.</p>
              </div>
            </div>
            <div v-else class="row mt-2">
              <div class="col-12">
                <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Notes</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
          </div>
        </div>
        <!-- File Uploads -->
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="bp_color">File Uploads</h5>
            </div>
          </div>
          <button @click="add_files_modal" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip"
            title="Upload Worker Files">
            <i class="fas fa-file-upload"></i> &nbsp;Upload File
          </button>
          <div v-if="files_loaded" class="row mt-1">
            <div v-if="notEmptyObject(files)" class="col-12">
              <h5 class="mb-2" style="font-size: 0.8rem; text-decoration: underline">IDENTITY FILES</h5>
              <div v-for="file in files" class="last_notes mb-2" v-if="file.type.ident.startsWith('id_')">
                <button @click="view_file_modal(file.id)" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                  title="View Worker File"><i class="fas fa-eye"></i></button>
                <div class="note_details">
                  <span class="note_type">{{ file.type.file_type }}</span>
                  <span
                    v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'"
                    class="note_user_created_at">{{ file.file_log_by.first_name }} {{ file.file_log_by.surname }} - {{
                      file.updated_at | formatDateTime
                    }}</span>
                  <span v-else class="note_user_created_at">Worker - {{ file.updated_at | formatDateTime }}</span>
                </div>
              </div>
              <h5 class="mb-2 mt-3" style="font-size: 0.8rem; text-decoration: underline">OTHER FILES</h5>
              <div v-for="file in files" class="last_notes mb-2" v-if="!file.type.ident.startsWith('id_')">
                <button @click="view_file_modal(file.id)" class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip"
                  title="View Worker File"><i class="fas fa-eye"></i></button>
                <div class="note_details">
                  <span class="note_type">{{ file.type.file_type }}</span>
                  <span
                    v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'"
                    class="note_user_created_at">{{ file.file_log_by.first_name }} {{ file.file_log_by.surname }} - {{
                      file.updated_at | formatDateTime
                    }}</span>
                  <span v-else class="note_user_created_at">Worker - {{ file.updated_at | formatDateTime }}</span>
                </div>
              </div>
            </div>
            <div v-else class="col-12 ri_w_no_content">
              <p class="ri_w_label">No Files Uploaded for worker.</p>
            </div>
          </div>
          <div v-else class="row mt-2">
            <div class="col-12">
              <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Files</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          </div>
        </div>

        <!--        &lt;!&ndash; Activity &ndash;&gt;-->
        <!--        <div class="ri_w_section">-->
        <!--          <div class="row">-->
        <!--            <div class="col-12">-->
        <!--              <h5 class="bp_color">Latest Activity on Record</h5>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <button @click="view_all_worker_activity" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="All worker activity">-->
        <!--            <i class="fas fa-stream"></i> &nbsp;View Activity-->
        <!--          </button>-->

        <!--          <div v-if="activity_loaded" class="row mt-1">-->
        <!--            <div v-if="notEmptyObject(activity)" class="col-12">-->
        <!--              <button @click="view_log_modal(log)" v-for="log in activity" class="last_activity" :class="log_type(log.type)">-->
        <!--                <span class="log_type">-->
        <!--                  <span class="log_icon">{{ log.type | capitalLogType }}</span>-->
        <!--                  <span v-if="'worker_model_type' in log">{{ log.worker_model_type | modelLog }}</span>-->
        <!--                  <span v-else-if="'contact_info_model_type' in log">{{ log.contact_info_model_type | modelLog }}</span>-->
        <!--                  <span v-else-if="'note_id' in log">Note</span>-->
        <!--                </span>-->
        <!--                <span class="log_user_created_at">{{ log.log_by.name }} - {{ log.updated_at | formatDateTime }}</span>-->
        <!--              </button>-->
        <!--            </div>-->
        <!--            <div v-else class="col-12 ri_w_no_content">-->
        <!--              <p class="ri_w_label">No Activity on worker.</p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div v-else class="row mt-2">-->
        <!--            <div class="col-12">-->
        <!--              <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Activity</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
        <declarations
            :worker="worker"
            :files="files"
            :is-accordion="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) || crmCompany === 'Genius Money'"
            :auto-open="false"
        />
    </div>
    <verify_reason_modal :worker_id="this.worker.id"></verify_reason_modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import loadingCube from "loaders/right_loader";
import verify_reason_modal from "../../partials/modals/worker/verify_reason.vue";
import declarations from './workers/declarations.vue';

export default {
  name: "workers",
  components: {
    loadingCube,
    verify_reason_modal,
    declarations
  },
  data() {
    return {
      worker_export: false,
      worker_loaded: false,
      worker_reg_verified: false,

      list_ac_export: {},
      list_p_export: {},
      list_t_export: {},

      worker: {},
      emails: {},
      phones: {},
      addresses: {},
      banks: {},

      entity_test_loaded: false,
      worker_compliance_test: {},

      notes_loaded: false,
      notes: {},

      assignments_loaded: false,
      assignments: {},
      most_recent_unassigned_assignments: {},

      files_loaded: false,
      files: {},
      files_uploaded: [],
      file_order: ['id_1', 'id_2', 'contract', 'application', 'pe_ins_cert', 'pi_ins_cert', 'vat_cert', 'other_1', 'other_2'],

      // activity_loaded: false,
      // activity: {}
    }
  },
  computed: {
    full_name() {
      return this.worker.person.first_name + ' ' + this.worker.person.surname;
    },
    in_ac_export() {
      
      // do not render Sage export buttons if worker not assigned or CRM is not V3
      // V3 does not use accounts to export
      if(!this.worker.is_assigned || this.crmType === 'recruitment') {
          return true;
      }

      return this.list_ac_export.find(ac => ac.worker_id === this.worker.id) !== undefined;
    },
    in_p_export() {
      
      // do not render Sage export buttons if worker not assigned
      if(!this.worker.is_assigned) {
          return true;
      }

      return this.list_p_export.find(p => p.worker_id === this.worker.id) !== undefined;
    },
    in_t_export() {

      // do not render Sage export buttons if worker not assigned
      if(!this.worker.is_assigned) {
          return true;
      }
      
      return this.list_t_export.find(p => p.worker_id === this.worker.id) !== undefined;
    },
    entity_test_reload() {
      return this.$store.state.workers.reload_entity_test;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    // activity_reload() {
    //   return this.$store.state.logs.reload_logs;
    // },
    assignment_reload() {
      return this.$store.state.assignments.reload_assignments;
    }
  },
  beforeMount() {
    // if we coming from order,  data.id = assignment_id, and have data.worker_id
    // if we coming from worker, data.id = worker_id
    if (this.$store.state.right_info.data.worker_id === undefined || this.$store.state.right_info.data.worker_id === null) {
      this.$store.state.right_info.data.worker_id = this.$store.state.right_info.data.id;
    }

    axios.get(this.crmApiPath + 'worker/' + this.$store.state.right_info.data.worker_id).then(worker => {
      this.worker = worker.data;

      let worker_promises = [];
      // Emails
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/email/worker/' + this.$store.state.right_info.data.worker_id).then(emails => {
          this.emails = emails.data;
          resolve();
        })
      }))
      // Phones
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/phone/worker/' + this.$store.state.right_info.data.worker_id).then(phones => {
          this.phones = phones.data;
          resolve();
        })
      }))
      // Addresses
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact_info/address/worker/' + this.$store.state.right_info.data.worker_id).then(addresses => {
          this.addresses = addresses.data;
          resolve();
        })
      })))

      // Finance Accounts Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/accounts/list_export').then(list_export => {
          this.list_ac_export = list_export.data;
          resolve();
        })
      })))
      // Finance Payroll Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/payroll/list_export').then(list_export => {
          this.list_p_export = list_export.data;
          resolve();
        })
      })))
      // Finance Tax Export List
      worker_promises.push((new Promise(resolve => {
        axios.get(this.crmApiPath + 'finance/export/worker/tax/list_export').then(list_export => {
          this.list_t_export = list_export.data;
          resolve();
        })
      })))

      // Banks
      worker_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'worker/bank/index/' + this.$store.state.right_info.data.worker_id).then(banks => {
          this.banks = banks.data;
          resolve();
        })
      }))

      //compliance test
      worker_promises.push(new Promise(resolve => {
        this.get_latest_worker_compliance_test().then(() => resolve());
      }))
      //notes
      worker_promises.push(new Promise(resolve => {
        this.get_worker_notes().then(() => resolve());
      }))
      //logs
      // worker_promises.push(new Promise(resolve => {
      //   this.get_worker_logs().then(() => resolve());
      // }))
      // Files
      worker_promises.push(new Promise(resolve => {
        this.get_worker_files().then(() => resolve());
      }))
      // Assignments
      worker_promises.push(new Promise(resolve => {
        this.get_latest_worker_assignment().then(() => resolve());
      }))

      Promise.all(worker_promises).then(() => this.worker_loaded = true)
    });
  },
  watch: {
    entity_test_reload(val) {
      if (val) {
        this.entity_test_loaded = false;
        this.get_latest_worker_compliance_test();
      }
    },
    note_reload(val) {
      if (val) {
        this.notes_loaded = false;
        this.get_worker_notes()
      }
    },
    file_reload(val) {
      if (val) {
        this.files_loaded = false;
        this.files_uploaded = [];
        this.get_worker_files()
      }
    },
    assignment_reload(val) {
      if (val) {
        this.assignments_loaded = false;
        this.get_latest_worker_assignment();
      }
    }
  },
  methods: {
    ...mapActions(['hideRightInfo']),

    verify_worker() {
      this.$root.$emit('bv::show::modal', 'verification_reason_modal');
      this.$root.$on('worker_account_verifying', (veryfying) => {
          if(veryfying === true) {
              this.worker_reg_verified = true;
              this.worker.new_starters.verified_at = 'Verifying ...';  
          } else {
              this.worker_reg_verified = false;
              this.worker.new_starters.verified_at = 'UNVERIFIED';
          }          
      });
      this.$root.$on('worker_account_verified', (date) => {
          this.worker_reg_verified = true;
          this.worker.new_starters.verified_at = date;
      });
    },
    /*
     * QUICK ACTIONS
     */
    add_to_finance_export_accounts() {
      axios.post(this.crmApiPath + 'finance/export/worker/accounts', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(ac_export => {
          this.list_ac_export = ac_export.data.data;
          this.$bus.$emit('worker:sage:export');
          this.$bvToast.toast('Worker added to accounts export list.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
      }).catch(error => {
        this.$bvToast.toast(error.response.data.error, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    add_to_finance_export_payroll() {
      axios.post(this.crmApiPath + 'finance/export/worker/payroll', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(p_export => {
          this.list_p_export = p_export.data.data;
          this.$bus.$emit('worker:sage:export');
          this.$bvToast.toast('Worker added to payroll export list.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
      }).catch(error => {
        this.$bvToast.toast(error.response.data.error, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    add_to_finance_export_tax() {
      axios.post(this.crmApiPath + 'finance/export/worker/tax', {
        worker_id: this.worker.id,
        user_id: this.$store.state.auth.me.id,
        exported: false,
      }).then(p_export => {
        this.list_t_export = p_export.data;
        this.$bvToast.toast('Worker added to tax export list.', {
            title: 'Success',
            variant: 'success',
            solid: true,
        });
      }).catch(error => {
        this.$bvToast.toast('Something went wrong', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      });
    },
    close_right_info() {
      this.hideRightInfo();
      this.$store.commit('CLEAR_RIGHT_INFO_TABLE_ROW');
    },
    export_worker() {
      this.worker_export = true;
      axios.post(this.crmApiPath + 'worker/export/' + this.worker.id).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        let name  = this.worker.person.first_name.replace(' ', '-').toLowerCase() + '_' +
            this.worker.person.surname.replace(' ', '-').toLowerCase();
        link.setAttribute('download', 'worker_export_' + name
            + '_' + this.$moment.utc().format('DD-MM-YYYY') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.$nextTick(() => this.worker_export = false)
      })
    },
    show_profile_worker() {
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.$store.state.right_info.data.worker_id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/workers/profile');
        this.$tabs.refresh('/workers/profile', true)
      });
    },
    show_edit_worker() {
      this.$store.commit('CURRENT_EDIT_WORKER_ID', this.$store.state.right_info.data.worker_id);
      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/workers/edit');
        this.$tabs.refresh('/workers/edit', true)
      });
    },
    delete_worker() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Worker</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to delete:<br>' + this.$store.state.right_info.data.full_name +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$store.commit('SET_DELETE_WORKER_ID', this.worker.id);

              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'worker/' + this.$store.state.right_info.data.worker_id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$bus.$emit('table::reload', { table: 'all_workers', type: 'delete' });
                this.$nextTick(() => this.close_right_info())
              });
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },

    createEmail() {
      this.$router.push('/email/create');
    },
    createEvent() {
      this.$router.push('/calendar/event/create');
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    /*
     * GET RIGHT INFORMATION
     */
    get_latest_worker_compliance_test() {
      return axios.get(this.crmApiPath + 'worker/compliance_test/worker/' + this.$store.state.right_info.data.worker_id + '/latest').then(worker_compliance_test => {
        if (worker_compliance_test !== undefined && worker_compliance_test !== null) {
          this.worker_compliance_test = worker_compliance_test.data;
        }
        this.entity_test_loaded = true;
      }).catch(error => console.log(error.response));
    },
    get_worker_notes() {
      return axios.get(this.crmApiPath + 'note/worker/' + this.$store.state.right_info.data.worker_id + '/last_3').then(worker_notes => {
        this.notes = worker_notes.data;
        this.notes_loaded = true;
      }).catch(error => console.log(error.response));
    },
    get_worker_files() {
      return axios.get(this.crmApiPath + 'file/worker/' + this.$store.state.right_info.data.worker_id).then(worker_files => {
        this.files = this.mapArrayOrder(worker_files.data, this.file_order, 'type');
        this.files.sort(function (a, b) {
          let file_a = a.type.file_type.toLowerCase(), file_b = b.type.file_type.toLowerCase();
          if (file_a < file_b) {
            return -1
          }
          if (file_a > file_b) {
            return 1
          }
        });

        this.files_loaded = true;
        this.$nextTick(() => this.files.forEach(file => this.files_uploaded.push(file.type.id)));

      }).catch(error => console.log(error.response));
    },
    get_latest_worker_assignment() {
      return axios.get(this.crmApiPath + 'assignments/worker/current_assignments/' + this.$store.state.right_info.data.worker_id).then(assignments => {
        this.assignments = assignments.data;
        axios.get(this.crmApiPath + 'assignments/worker/most_recent_unassigned/' + this.$store.state.right_info.data.worker_id).then(most_recent => {
          this.most_recent_unassigned_assignments = most_recent.data
          this.assignments_loaded = true;
        })
      });
    },

    /*
     * SECTION FUNCTIONS
     */
    view_all_assignments() {
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.$store.state.right_info.data.worker_id);
      // PAYE
      let tab_index = 0;
      if (this.worker.rel_company_info.employment_type_id === 33) {
        tab_index = 3;
      }
      // Sole Trader / LTD company
      else if (this.worker.rel_company_info.employment_type_id === 30 || this.worker.rel_company_info.employment_type_id === 29 ||
        this.worker.rel_company_info.employment_type_id === 32) {
        tab_index = 6;
      }
      // NO employment status
      else {
        tab_index = 3;
      }
      if (this.worker.rel_services.recruitment) {
        tab_index = tab_index + 1;
      }
      this.$store.commit('SET_WORKER_TAB_INDEX', tab_index);
      this.$nextTick(() => {
        this.$router.push('/workers/profile');
        this.$tabs.refresh('/workers/profile', true)
      });
    },
    end_current_assignment(assignment_id) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm End of Assignment</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to end this assignment' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              let assignment = {
                worker_id: this.$store.state.right_info.data.worker_id,
                client_id: this.assignments[0].client_id,
                order_job_id: this.assignments[0].order_job_id,
                position_rate_id: this.assignments[0].position_rate_id,
                assigned_by_id: this.$store.state.auth.me.id,
                start_date: this.assignments[0].start_date,
                end_date: this.$moment().utc().format('YYYY-MM-DD'),
                assigned: false,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              };
              axios.post(this.crmApiPath + 'timesheet/record/end_assignment/' + assignment_id).then(() => {
                axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + assignment_id, assignment).then(() => {

                  this.$snotify.remove(toast.id);
                  this.$bus.$emit('assignments::reload', { action: true });
                });
              });
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    show_assignment_order() {
      this.$store.commit('CURRENT_ORDER_ID', this.assignments[0].order_job_id);
      this.$store.commit('SET_ORDER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/order/view');
        this.$tabs.refresh('/order/view', true)
      });
    },
    new_assignment() {
      this.$store.commit('CURRENT_NEW_ASSIGNMENT_WORKER_ID', {
        worker_id: this.$store.state.right_info.data.worker_id,
        compliance_test_id: null
      });
      // Close current tab and open up worker assignment
      this.$nextTick(() => {
        this.$router.push('/workers/assignment');
        this.$tabs.refresh('/workers/assignment', true);
      });
    },
    view_entity_test(id) {
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.$store.state.right_info.data.worker_id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 1);

      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/workers/profile');
        this.$tabs.refresh('/workers/profile', true)
      });
    },
    new_entity_test() {
      this.$store.commit('CURRENT_NEW_ENTITY_TEST_WORKER_ID', this.$store.state.right_info.data.worker_id);
      this.$nextTick(() => this.$router.push('/workers/entity_test/new'));
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.worker.id,
        name: this.full_name,
        type: 'worker',
        contacts: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    view_note_modal(note_id) {
      this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
        id: note_id,
        name: this.full_name,
        type: 'worker',
        contacts: null
      });
      this.$store.state.notes.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
    },
    view_notes_list_modal(note_id) {
      this.$store.commit('SHOW_VIEW_NOTES_LIST_MODAL', {
        id: note_id,
        name: this.full_name,
        type: 'worker',
        contacts: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_notes_list_modal'));
    },
    add_files_modal() {
      this.$store.commit('SHOW_ADD_FILE_MODAL', {
        id: this.worker.id,
        name: this.full_name,
        employment_type: this.worker.rel_company_info.employment_type.value,
        type: 'worker',
        vat_registered: this.worker.rel_company_info.vat_registered,
        uploaded_files: this.files_uploaded,
        nationality: this.worker.person.nationality,
      });
      this.$store.state.files.add_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'upload_file_modal'));
    },
    view_file_modal(file_id) {
      this.$store.commit('SHOW_VIEW_FILE_MODAL', {
        id: file_id,
        type: 'worker'
      });
      this.$store.state.files.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
    },
    // view_all_worker_activity() {
    //   this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.$store.state.right_info.data.worker_id);
    //   this.$store.commit('SET_WORKER_TAB_INDEX', 10);
    //   this.$nextTick(() => {
    //     this.$router.push('/workers/profile');
    //     this.$tabs.refresh('/workers/profile', true)
    //   });
    // },
    // log_type(type) {
    //   if (type === 'created') {
    //     return 'created';
    //   }
    //   else if (type === 'updated') {
    //     return 'updated';
    //   }
    //   else if (type === 'restored') {
    //     return 'restored';
    //   }
    //   else if (type === 'deleted') {
    //     return 'deleted';
    //   }
    // },
    // view_log_modal(log) {
    //   this.$store.commit('SHOW_VIEW_LOG_MODAL', {
    //     log_type: 'worker',
    //     id: log.id,
    //     log_by: log.log_by,
    //     log_by_id: log.log_by_id,
    //     log_by_type: log.log_by_type,
    //     new_values: log.new_values,
    //     old_note_by: log.old_note_by,
    //     old_values: log.old_values,
    //     type: log.type,
    //     updated_at: log.updated_at,
    //     worker_id: log.worker_id,
    //     worker_model_id: log.worker_model_id,
    //     worker_model_type: log.worker_model_type,
    //   });
    //   this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
    // },
  }
}
</script>

<style scoped lang="scss">
.r_h_100 {
  height: calc(100vh - 43px);
}

#worker_right_info {
  width: $right_info_width;
  padding-top: 0;

  .row {
    margin-right: 0;
    margin-left: 0;

    &.extra_neg_margin {
      margin-right: -10px;
      margin-left: -10px;
    }
  }

  .latest_assignment_buttons,
  .latest_assignment {
    vertical-align: middle;
  }

  .latest_assignment_buttons {
    display: inline-block;
    position: relative;
    width: 45px;
    margin-right: 5px;

    button {
      float: none !important;

      &:first-of-type {
        margin-bottom: 5px;
      }
    }
  }

  .latest_assignment {
    display: inline-block;
    width: calc(100% - 60px);
  }

  #ri_w_top {
    background-color: $right_info_bg;
    right: 0;
    width: 400px;
    padding: 10px 20px 10px 10px;
    z-index: 9;
  }

  .ri_w_after_top {
    width: 100%;
    padding-right: 20px;
  }

  .quick_btns,
  .quick_action_btns {
    .orcaBtn {
      width: auto;
      padding: 0 15px;
      line-height: 30px;
      font-size: 0.65rem;
    }
  }

  .ri_w_section {
    display: block;
    position: relative;

    .sm-btn {
      width: auto;
      padding: 0 15px;
      line-height: 30px;
      font-size: 0.65rem;
      float: right;
    }

    .top_right_btn {
      position: absolute;
      right: 5px;
      top: -5px;
    }

    .ri_w_label {
      display: inline-block;
      line-height: 30px;
      margin-bottom: 0;
    }

    .ri_w_no_content {
      background: $red;
      padding-top: 5px;
      padding-bottom: 5px;

      .ri_w_label {
        color: $white;
      }
    }

    .ri_w_loading {
      display: inline-block;
      line-height: 30px;
      margin-bottom: 0;
      font-size: 1rem;
    }

    .latest_entity_test {
      margin-bottom: 0;

      &.Fail,
      &.Amber {
        color: $white;
        padding-top: 5px;
        padding-bottom: 5px;
      }

      &.Fail {
        background: $red;
      }

      &.Amber {
        background: $orange;
      }

      &.Pass {
        .test_status {
          color: $green;
        }
      }

      button {
        float: none;
        vertical-align: middle;
        margin-right: 10px;
      }

      .test_status {
        width: 70px;
        display: inline-block;
        vertical-align: middle;
        line-height: 1.1;
        font-weight: bold;
        font-size: 1rem;
        text-transform: uppercase;
      }

      .test_info {
        width: calc(100% - 130px);
        display: inline-block;
        vertical-align: middle;

        .test_date,
        .test_created_at {
          line-height: 1.1;
          display: block;
          font-size: 0.625rem;
        }

        .test_date {
          font-weight: bold;
        }

        .test_created_at {
          margin-top: 3px;
        }
      }
    }

    .last_notes {
      margin-bottom: 15px;

      button {
        float: none;
        vertical-align: middle;
        margin-right: 10px;
      }

      .note_details {
        width: calc(100% - 56px);
        display: inline-block;
        vertical-align: middle
      }

      .note_type,
      .note_title,
      .note_user_created_at {
        line-height: 1.1;
        display: block;
      }

      .note_type {
        font-weight: bold;
        font-size: 0.9rem;
      }

      .note_title {
        margin-top: 3px;
      }

      .note_user_created_at {
        font-size: 0.625rem;
        margin-top: 3px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .last_activity {
      margin-bottom: 3px;
      border: none;
      background: transparent;
      padding: 5px 5px 7px 5px;
      display: block;
      width: 100%;
      text-align: left;

      &:focus {
        outline: none;
      }

      .log_type {
        display: block;
        font-weight: bold;

        .log_icon {
          font-size: 0.65rem;
          display: inline-block;
          margin-right: 10px;
          border: 2px solid;
          border-radius: 50%;
          text-align: center;
          height: 20px;
          width: 20px;
          line-height: 17px;
        }
      }

      .log_user_created_at {
        font-size: 0.65rem;
        line-height: 10px;
        height: 10px;
        display: block;
        margin-left: 34px;
      }

      &.created,
      &.updated,
      &.restored,
      &.deleted {

        &:hover,
        &:focus,
        &:active,
        &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
          color: $white;
          border-radius: $border-radius_2;
        }
      }

      &.created {
        color: $green;
        border-color: $green;

        &:hover,
        &:focus,
        &:active,
        &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
          background: $green;
        }
      }

      &.updated {
        color: $blue;
        border-color: $blue;

        &:hover,
        &:focus,
        &:active,
        &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
          background: $blue;
        }
      }

      &.restored {
        color: $orange;
        border-color: $orange;

        &:hover,
        &:focus,
        &:active,
        &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
          background: $orange;
        }
      }

      &.deleted {
        color: $red;
        border-color: $red;

        &:hover,
        &:focus,
        &:active,
        &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
          background: $red;
        }
      }
    }
  }

}
</style>
